export const FETCH_MAINTENANCE_MODE = "FETCH_MAINTENANCE_MODE"
export const FETCH_MAINTENANCE_MODE_SUCCESS = "FETCH_MAINTENANCE_MODE_SUCCESS"
export const FETCH_MAINTENANCE_MODE_FAILURE = "FETCH_MAINTENANCE_MODE_FAILURE"
export const SET_MAINTENANCE_MODE = "SET_MAINTENANCE_MODE"
